/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, func, shape, string, bool, arrayOf,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import CgcEditor from '../RTE/CgcEditor';

const styles = (theme) => ({
    container: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-around',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'row-reverse',
            justifyContent: 'end',
            display: 'block',
        },
    },
    cardWrapper: {
        display: 'flex',
        marginTop: 40,
        justifyContent: 'flex-end',
        [theme.breakpoints.down(1660)]: {
            marginTop: 20,
        },
        [theme.breakpoints.up('sm')]: {
            padding: '0 8px',
        },
    },

    cardWrapperHorizontal: {
        flexDirection: 'column',
        alignItems: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center',
        },
    },

    cardFlipSideVertical: {
        marginTop: '-15px',
        width: '300px',
        maxHeight: '570px',
        minHeight: '570px',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        transform: 'skewY(6deg)',
        boxShadow: `0px 4px 4px ${theme.palette.cgc?.cardFlipShadow || 'rgba(0,0,0,0.25)'} `,
        background: theme.palette.cgc?.bgCardFlip || 'linear-gradient(271.54deg, #C4C4C4, #B6B6B6 0.59%, #F0F0F0 97.6%);',
        [theme.breakpoints.down(1660)]: {
            width: '240px',
            maxHeight: 350,
            minHeight: 350,
            marginTop: '-10px',
            transform: 'skewY(5deg)',
        },
        [theme.breakpoints.down('xs')]: {
            width: '20%',
            transform: 'skewY(3deg)',
            marginTop: -2,
            maxHeight: 370,
            minHeight: 370,
        },

    },
    cardFlipSideHorizontal: {
        marginRight: '13px',
        width: '380px',
        maxHeight: '256px',
        minHeight: '256px',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        transform: 'skewX(6deg)',
        background: theme.palette.cgc?.bgCardFlip || 'linear-gradient(91.54deg, #C4C4C4, #B6B6B6 0.59%, #F0F0F0 97.6%);',
        [theme.breakpoints.down(1660)]: {
            width: 350,
            maxHeight: '240px',
            minHeight: '240px',
            marginRight: '10px',
            transform: 'skewX(5deg)',
        },
        [theme.breakpoints.down('xs')]: {
            maxHeight: 40,
            minHeight: 40,
            marginRight: 22,
            transform: 'skewX(27deg)',
        },
    },
    editCardSideVertical: {
        width: '384px',
        maxHeight: '570px',
        minHeight: '570px',
        display: 'flex',
        boxSizing: 'border-box',
        border: `16px solid ${theme.palette.cgc?.bgCardFront || '#c4c4c4'}`,
        boxShadow: `0px 4px 4px ${theme.palette.cgc?.cardFlipShadow || 'rgba(0,0,0,0.25)'} `,
        [theme.breakpoints.down(1660)]: {
            width: '280px',
            maxHeight: 350,
            minHeight: 350,
        },
        [theme.breakpoints.down('xs')]: {
            width: '80%',
            maxHeight: 370,
            minHeight: 370,
            marginRight: 35,
        },
    },
    editCardSideHorizontal: {
        width: '380px',
        maxHeight: '256px',
        minHeight: '256px',
        display: 'flex',
        boxSizing: 'border-box',
        border: `16px solid ${theme.palette.cgc?.bgCardFront || '#c4c4c4'}`,
        boxShadow: `0px 4px 4px ${theme.palette.cgc?.cardFlipShadow || 'rgba(0,0,0,0.25)'} `,
        [theme.breakpoints.down(1660)]: {
            width: 350,
            maxHeight: '280px',
            minHeight: '280px',
        },
    },
    textEditor: {
        marginTop: 40,
        marginLeft: 40,
        [theme.breakpoints.down(1660)]: {
            marginTop: 20,
        },
        [theme.breakpoints.down('sm')]: {
            margin: '20px 0',
        },
        [theme.breakpoints.down('480')]: {
            margin: '10px 0',
            display: 'flex',
            justifyContent: 'center',
        },
        zIndex: 1000,
    },
    textArea: {
        resize: 'none',
        width: '100%',
        fontSize: 16,
        padding: 4,
        overflow: 'hidden',
    },

});

class CardInside extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            text: '',
            style: {},
            fontLimit: null,
        };
    }

    componentDidMount() {
        const { messageData, toolbarProps } = this.props;
        const fontFamliyData = toolbarProps?.filter((item) => item?.value === 'font');
        const font = fontFamliyData?.[0]?.list?.[0];
        this.setState({ fontLimit: font?.maxChar, style: { fontFamily: font?.value } });
        if (messageData?.text) {
            this.setState({
                text: messageData?.text,
                style: messageData?.style,
            });
        }
    }

    removedSpecialChars = (text) => {
        if (text) {
            /**
             *  \p{L} - allows all letters
             *  \p{N} - allows numbers
             *  \p{P} - allows punctuation
             *  \p{Z} - allows whitespace separators
             *  ^$ - allowing "$" and "^"
             *  \n - allowing new line
             *
             * return - Remove emoji from string.
             */
            return text?.replace?.(/[^\p{L}\p{N}\p{P}\p{Z}{^$}\n]/gu, '');
        }
        return '';
    }

    updateMessageData = () => {
        const { text, style } = this.state;
        const { setCardMessage } = this.props;
        const messageData = {
            style, text,
        };
        if (messageData?.text) {
            messageData.text = this.removedSpecialChars(messageData.text);
        }
        setCardMessage(messageData);
    }

    handleChange = (e) => {
        const val = e.target.value;
        this.setState({
            text: this.removedSpecialChars(val),
        }, () => this.updateMessageData());
    };

    handleStyle = (style) => {
        const { toolbarProps } = this.props;
        const { text } = this.state;
        const fontFamliyData = toolbarProps?.filter((item) => item?.value === 'font');
        const font = fontFamliyData?.[0]?.list?.filter((fontData) => fontData?.value === style.fontFamily);
        const controlledText = text?.substr(0, font?.[0]?.maxChar);
        this.setState({
            style, fontLimit: font?.[0]?.maxChar, text: controlledText,
        }, () => this.updateMessageData());
    }

    render() {
        const { classes, toolbarProps, isHorizontal } = this.props;
        const { text, style, fontLimit } = this.state;
        return (
            <Grid item xs={12} className={classes.container}>
                <Grid item sm={8} md={8} xs={12} className={`${classes.cardWrapper} ${isHorizontal ? classes.cardWrapperHorizontal : ''}`}>
                    <div className={isHorizontal ? classes.cardFlipSideHorizontal : classes.cardFlipSideVertical} />
                    <div className={isHorizontal ? classes.editCardSideHorizontal : classes.editCardSideVertical}>
                        <textarea
                            className={classes.textArea}
                            onChange={(e) => this.handleChange(e)}
                            value={text}
                            style={style}
                            placeholder="Please Enter Your Message..."
                            maxLength={fontLimit}
                        />
                    </div>
                </Grid>
                <Grid item md={4} sm={8} xs={12} className={classes.textEditor}>
                    <CgcEditor
                        greetingCard
                        style={style}
                        handleStyle={this.handleStyle}
                        toolbarProps={toolbarProps}
                    />
                </Grid>
            </Grid>
        );
    }
}
CardInside.propTypes = {
    isHorizontal: bool.isRequired,
    classes: object.isRequired,
    setCardMessage: func.isRequired,
    messageData: shape({
        text: string,
        style: shape({
            textAlign: string.isRequired,
            color: string.isRequired,
        }).isRequired,
    }).isRequired,
    toolbarProps: arrayOf(shape({
        value: string,
        label: string,
        icon: string,
        title: string,
        type: string,
        list: arrayOf(shape({
            label: string,
            value: string,
        })),
    })),
};
CardInside.defaultProps = {
    toolbarProps: {},
};
export default withStyles(styles)(CardInside);
